<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col>
            <b-form-datepicker
              v-model="filterData.sdate"
              v-bind="{labelNoDateSelected: 'Başlangıç Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
              locale="tr"
              start-weekday="1"
            />
          </b-col>
          <b-col>
            <b-form-datepicker
              v-model="filterData.edate"
              v-bind="{labelNoDateSelected: 'Bitiş Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
              locale="tr"
              start-weekday="1"
            />
          </b-col>
          <b-col
            v-if="filterData.sdate || filterData.edate"
            cols="12"
            md="auto"
          >
            <b-button
              variant="warning"
              @click="resetFilter"
            >
              <feather-icon icon="XCircleIcon" />
            </b-button>
          </b-col>
          <b-col
            cols="12"
            md="auto"
          >
            <b-button
              variant="primary"
              @click="dataFilter"
            >
              <feather-icon icon="FilterIcon" />
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
      <template v-if="dataList.length > 0">
        <b-table
          responsive="sm"
          :fields="fields"
          :items="dataList"
          striped
          small
        >
          <template #cell(action)="data">
            <b-badge
              v-if="data.item.action === 'modified'"
              variant="light-warning"
            >
              <feather-icon icon="EditIcon" />
              Düzenleme
            </b-badge>
            <b-badge
              v-if="data.item.action === 'deleted'"
              variant="light-danger"
            >
              <feather-icon icon="TrashIcon" />
              Silme
            </b-badge>
            <b-badge
              v-if="data.item.action === 'created'"
              variant="light-primary"
            >
              <feather-icon icon="PlusIcon" />
              Oluşturma
            </b-badge>
            <div>
              <small class="text-muted">{{ moment(data.item.created).format('DD.MM.YYYY HH:mm:ss') }}</small>
            </div>
          </template>
          <template #cell(control)="data">
            <div class="text-right">
              <b-button
                variant="outline-primary"
                size="sm"
                :to="$route.path + '/view/' + data.item.id"
              >
                Görüntüle
              </b-button>
            </div>
          </template>
        </b-table>
        <b-card-footer>
          <b-pagination
            v-model="currentPage"
            :total-rows="dataCounts"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-card-footer>
      </template>
      <b-alert
        v-else
        show
        variant="info"
        class="m-2"
      >
        <div class="alert-body text-center">
          <FeatherIcon icon="InfoIcon" />
          Kayıtlı veri bulunamadı.
        </div>
      </b-alert>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BCol, BRow, BCardBody, BCardFooter, BPagination, BTable, BButton, BAlert, BBadge, BFormDatepicker,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const tableName = 'event_logs'

export default {
  name: 'Index',
  components: {
    BFormDatepicker,
    BAlert,
    BCard,
    BCol,
    BRow,
    BCardBody,
    BCardFooter,
    BPagination,
    BTable,
    BButton,
    BBadge,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'username',
          label: 'Gerçekleştiren',
        },
        { key: 'ip_address', label: 'İp Adres' },
        {
          key: 'component',
          label: 'Modül',
          thStyle: { width: '180px' },
        },
        {
          key: 'action',
          label: 'İşlem',
          thStyle: { width: '130px' },

        },

        {
          key: 'control',
          label: '',
          thStyle: { width: '180px' },
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.data AS data`,
          `${tableName}.component AS component`,
          `${tableName}.action AS action`,
          `${tableName}.ip_address AS ip_address`,
          `${tableName}.created AS created`,
          'users.name AS username',
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['eventLogs/dataList']
    },
    filterData() {
      return this.$store.getters['eventLogs/filterData']
    },
    dataCounts() {
      return this.$store.getters['eventLogs/dataCounts']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.getDataList()
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
        this.getDataList()
      }
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    resetFilter() {
      this.$store.commit('eventLogs/RESET_FILTER_DATA')
      this.getDataList()
    },
    dataFilter() {
      const where = {}
      if (this.filterData.sdate) {
        where['date(event_logs.created) >='] = this.filterData.sdate
      }
      if (this.filterData.edate) {
        where['date(event_logs.created) <='] = this.filterData.edate
      }
      this.dataQuery.where = where
      this.getDataList()
    },
    getDataList() {
      this.$store.dispatch('eventLogs/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('eventLogs/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
